import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  TextField,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { Control, Controller, FieldValues } from 'react-hook-form';

import { EnumSelect } from '~/components/GenericForm/EnumSelect';
import { convertToMomentOrNull } from '~/utils/helper';

import { CustomFieldTypes, InputProps } from '../types';

//TODO FIX ALIGNMENT HACKISH HELPER TEXT

export const CustomDataFieldComponent = (props: {
  type: string;
  control: Control<FieldValues>;
  inputProps: InputProps;
  label: string;
  shrinkLabel?: boolean;
}) => {
  const { type, control, inputProps, label, shrinkLabel } = props;

  const { validationRules, defaultValue, options, ...inputProperties } =
    inputProps;

  switch (type) {
    case CustomFieldTypes.DATE:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <DatePicker
              {...inputProperties}
              label={label}
              value={convertToMomentOrNull(value)}
              onChange={(v) => onChange(!!v ? v.format('YYYY-MM-DD') : null)}
              slotProps={{
                textField: {
                  error: !!error?.message,
                  helperText: error?.message,
                  fullWidth: inputProps.fullWidth,
                  size: 'small',
                  InputLabelProps: { shrink: shrinkLabel },
                },
              }}
            />
          )}
        />
      );
    case CustomFieldTypes.TEXT:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            const maxLength = validationRules
              ? validationRules['maxLength' as keyof object]
              : undefined;

            return (
              <TextField
                onChange={onChange}
                inputProps={{
                  maxLength,
                }}
                value={value}
                label={label}
                multiline
                fullWidth
                disabled={inputProperties.disabled}
                maxRows={5}
                size={'small'}
                error={!!error?.message}
                data-testid="custom-data-text-input"
                helperText={
                  !!maxLength
                    ? `${value ? value.length : 0}/${maxLength}`
                    : undefined
                } // TODO include error?.message into helperText somehow
                InputLabelProps={{ shrink: shrinkLabel }}
              />
            );
          }}
        />
      );
    case CustomFieldTypes.STRING:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            const maxLength = validationRules
              ? validationRules['maxLength' as keyof object]
              : undefined;

            return (
              <TextField
                onChange={onChange}
                inputProps={{
                  maxLength,
                }}
                value={value}
                label={label}
                fullWidth
                disabled={inputProperties.disabled}
                size={'small'}
                error={!!error?.message}
                data-testid="custom-data-string-input"
                helperText={
                  !!maxLength
                    ? `${value ? value.length : 0}/${maxLength}`
                    : undefined
                }
                // TODO include error?.message into helperText somehow
                InputLabelProps={{ shrink: shrinkLabel }}
              />
            );
          }}
        />
      );
    case CustomFieldTypes.NUMBER:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              onChange={(e) =>
                e.target.value === ''
                  ? onChange(null)
                  : onChange(e.target.value.replace(',', '.'))
              }
              label={label}
              fullWidth
              value={value || ''}
              size={'small'}
              error={!!error?.message}
              helperText={error?.message}
              disabled={inputProperties.disabled}
              data-testid="custom-data-number-input"
              InputLabelProps={{ shrink: shrinkLabel }}
            />
          )}
        />
      );
    case CustomFieldTypes.BOOLEAN:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <FormControl error={!!error}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    onChange={(_e, checked) => onChange(checked.toString())}
                    checked={value === 'true'}
                    disabled={inputProperties.disabled}
                    data-testid="custom-data-checkbox"
                  />
                }
                label={label}
              />
              {!!error?.message && (
                <FormHelperText>{error?.message}</FormHelperText>
              )}
            </FormControl>
          )}
        />
      );
    case CustomFieldTypes.ENUM:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <EnumSelect
              {...inputProperties}
              FormControlProps={{ fullWidth: true, size: 'small' }}
              value={value ?? ''}
              onChange={onChange}
              enumOptions={options}
              label={label}
              error={!!error?.message}
              helperText={error?.message}
              data-testid="custom-data-enum-select"
              shrink={shrinkLabel}
            />
          )}
        />
      );
    case CustomFieldTypes.MULTISELECT:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <EnumSelect
              {...inputProperties}
              FormControlProps={{ fullWidth: true, size: 'small' }}
              value={value || []}
              onChange={onChange}
              enumOptions={options}
              label={label}
              multiple
              error={!!error?.message}
              helperText={error?.message}
              data-testid="custom-data-enum-multiselect"
              shrink={shrinkLabel}
            />
          )}
        />
      );

    default:
      return <h1>No project match</h1>;
  }
};
